export default __webpack_public_path__ + "static/announce_b.6e446aacf5a65a720a020d59e1480a95.svg";